export default __webpack_public_path__ + "static/media/saudi_arab.803c17e0.svg";